import { GroupType } from './domain';
import { GroupId } from './groups';

export interface DisplayRegion {
    id: string;
    center?: number[]; // TODO отказаться
    text: string;
}

export interface Orientation {
    vertical: boolean;
    horizontal: boolean;
}

interface BaseScreen {
    id: string;
    screenWeight: number;
    deletedScreenWeight?: number;
    format?: string;
    address?: string;
    provider?: string;
    resolution?: string;
    caption?: string;
    zoneCategory?: string;
    facilityType?: string;
    facilityTypeId?: number;
    operatorName?: string;
    isDeleted?: boolean;
    orientation?: Orientation;
}

export interface IndoorScreen extends BaseScreen {
    aspectRatio: number[];
}

export interface OutdoorScreen extends BaseScreen {
    transform: number;
}

export type Screen = IndoorScreen | OutdoorScreen;

export interface DisplayPoint {
    id: string;
    coordinates: number[];
    regionId: string;
    screens: Screen[];
    caption?: string;
    operatorName?: string;
    zoneCategory?: string;
    facilityType?: string;
    transform?: number;
}

interface BaseDisplayListItem {
    id: string;
    zoneCategory: string;
    facilityType: string;
    address: string;
    coordinates: number[];
    regionId: string;
    screens: Screen[];
    caption: string;
    duration: string;
    regionText: string;
    height: string;
    width: string;
    hidden?: boolean;
    deleted?: boolean;
    imageLink?: string;
    gid?: string;
}

export interface IndoorDisplayListItem extends BaseDisplayListItem {
    // screens: IndoorScreen[];
}

export interface OutdoorDisplayListItem extends BaseDisplayListItem {
    // screens: OutdoorScreen[];
    operatorName: string;
    resolution: { width: number; height: number };
}

export type DisplayListItem = OutdoorDisplayListItem | IndoorDisplayListItem;

export interface SelectedScreens {
    [id: string]: string[];
}

export interface DisplayPageBlock {
    impId: string;
    pageId: string;
}

export interface MapCommonData {
    screenGroupsByRegion: {
        [id: string]: DisplayListItem[];
    };
    regions: DisplayRegion[];
    dictionary: Dictionary;
    facilities?: string[];
}

export interface OutdoorMapCommonData extends MapCommonData {
    // screenGroupsByRegion: {
    //     [id: string]: DisplayListItem[];
    // };
    // dictionary: OutdoorDictionary;
    operators?: string[];
}

export interface IndoorMapCommonData extends MapCommonData {
    // screenGroupsByRegion: {
    //     [id: string]: IndoorDisplayListItem[];
    // };
    // dictionary: IndoorDictionary;
    zones?: string[];
}

export enum PointColor {
    green = '#00e000',
    blue = '#0097ff',
    red = '#ff2e39',
    grey = '#979797'
}

export interface FiltersValue {
    [name: string]: string[];
}

export enum MapType {
    indoor = 'indoor',
    outdoor = 'outdoor'
}

export interface CheckBoxChangeData {
    id: string;
    regionId: string;
    checked: boolean;
}

export interface BaseMapDictionary {
    region: {
        [id: number]: DisplayRegion;
    };
    facility: {
        [id: number]: string;
    };
}

export interface IndoorDictionary extends BaseMapDictionary {
    zone: {
        [id: number]: string;
    };
}

export interface OutdoorDictionary extends BaseMapDictionary {
    operator: {
        [id: number]: string;
    };
}

export type Dictionary = IndoorDictionary | OutdoorDictionary;

export interface OutdoorMapEditorState {
    groupId: GroupId;
    isVisible: boolean;
    checkedByRegion?: SelectedScreens;
}

export interface IndoorMapEditorState {
    groupId: GroupId;
    isVisible: boolean;
    checkedByRegion?: SelectedScreens;
}

export interface PlatformsPreviewEditorState {
    isOpen: boolean;
    openedRegions: string[];
    type: GroupType;
}

export interface PreviewScreens {
    activeScreens: Screen[];
    inactiveScreens: Screen[];
}

export interface PolygonData {
    polygons?: ymaps.GeoObjectCollection;
    activePolygon: ymaps.Polygon;
    isDrawEnabled: boolean;
}

export interface DisplayPageBlockData {
    operatorName?: string;
    screensCount: number;
    facility: string;
    region: string;
    regionId: string;
    zone?: string;
}
